// ── Per-tenant theming (client portal) ──
// The portal's B/D color tokens (App.js) resolve through CSS variables (--brand-*, defaults
// in index.css). A per-tenant deployment overrides any subset at runtime by rewriting those
// variables on :root — nothing else changes.
//
// Source, for a single-tenant-per-deployment model, is a build-time env var baked into that
// tenant's bundle:
//   REACT_APP_BRAND_JSON = {"cyan":"#0a7","sidebar":"#111","headerBar":"#111"}
// (only the keys you want to change; the rest keep the Aequum defaults). Or call
// applyTenantTheme(obj) directly with an API-sourced config.

// token key (matches App.js B/D keys) -> CSS variable name
export const BRAND_TOKENS = {
  cyan:          "--brand-cyan",
  cyanDark:      "--brand-cyan-dark",
  cyanLight:     "--brand-cyan-light",
  navyDeep:      "--brand-navy-deep",
  bg:            "--brand-bg",
  sidebar:       "--brand-sidebar",
  sidebarHover:  "--brand-sidebar-hover",
  sidebarActive: "--brand-sidebar-active",
  navText:       "--brand-nav-text",
  navLabel:      "--brand-nav-label",
  navBorder:     "--brand-nav-border",
  card:          "--brand-card",
  cardBorder:    "--brand-card-border",
  headerBar:     "--brand-header-bar",
  tableHead:     "--brand-table-head",
  text:          "--brand-text",
  textDim:       "--brand-text-dim",
  label:         "--brand-label",
  rowHover:      "--brand-row-hover",
  tabBorder:     "--brand-tab-border",
};

// Apply a tenant's brand overrides to the document root. Safe with null/partial.
export function applyTenantTheme(brand) {
  if (!brand || typeof document === "undefined") return;
  const root = document.documentElement;
  for (const [key, cssVar] of Object.entries(BRAND_TOKENS)) {
    const val = brand[key];
    if (val) root.style.setProperty(cssVar, val);
  }
}

// Read the build-time brand config (per-tenant bundle). Returns null if unset/invalid.
export function loadBrandFromEnv() {
  try { return JSON.parse(process.env.REACT_APP_BRAND_JSON || "null"); }
  catch (e) { return null; }
}
